import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { AtmEquipmentService } from 'src/app/services/equipments/atm-equipment.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent {
  @Input() atm: any;
  @Input() reportData: any;
  @Output() typeSelect = new EventEmitter<{ type: String,sensor: any }>();

   mask: boolean = false;
   btnSelected: string = "no_trans";
   

  ngOnChanges(changes: SimpleChanges) {
    if (changes['reportData'] && changes['reportData'].currentValue) {
      this.initializeAtm();
    }
  }

  private initializeAtm() {
    if (!this.reportData) {
      this.reportData = {
        hoursInactive: 0,
        hoursActive: 0,
        numberTransactions: 0,
        countOpenVaul: 0,
        timeForUser: 0
      };
    } else {
      this.reportData.hoursInactive = this.reportData.hoursInactive || 0;
      this.reportData.hoursActive = this.reportData.hoursActive || 0;
      this.reportData.numberTransactions = this.reportData.numberTransactions || 0;
      this.reportData.countOpenVaul = this.reportData.countOpenVaul || 0;
      this.reportData.timeForUser = this.reportData.timeForUser || 0;
    }
  }

  selectReportingBtn(type:string,sensorId:any,sensorType:string,select:string){
    this.btnSelected=select
    let sensor = [
      {
          sensorId: sensorId, 
          type: sensorType
      },
    ];
    this.typeSelect.emit({ type: type,sensor:sensor });
  }

}
